import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M12.7751 10.7681C14.1659 9.62855 14.8609 8.93372 15.9452 7.59806C14.8609 6.26235 14.166 5.56753 12.7751 4.42799M9.06261 7.59803L15.9397 7.59796L9.06261 7.59803Z"
      stroke="#ECECEC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.35873 1.36546C2.96788 2.50499 2.2729 3.19982 1.18862 4.53556C2.27288 5.87121 2.96786 6.56604 4.35868 7.70562M1.18599 4.53559L8.07118 4.53553L1.18599 4.53559Z"
      stroke="#ECECEC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const Arrows = memo(ForwardRef);
export default Arrows;
